import RoutesMap from "../../route_control/RouteControl"
import {
    RegionList,
    AddRegion,
    UpdateRegion,
    GradeList,
    AddGrade,
    UpdateGrade,
    CustomerGroupList,
    AddCustomerGroup,
    UpdateCustomerGroup,
    CustomerTypeList,
    AddCustomerType,
    UpdateCustomerType,
    CustomerList,
    AddCustomer,
    UpdateCustomer,
    CustomerDetails,
    CategoryList,
    AddCategory,
    UpdateCategory,
    RoutesList,
    AddRoutes,
    UpdateRoutes,
    RouteDetails,
    CustomerRouteAssignmentList,
    AddCustomerRouteAssignment,
    UpdateCustomerRouteAssignment,
    CustomerSalesOrderList,
    AddCustomerSalesOrder,
    UpdateCustomerSalesOrder,
    DispatchAdviceRoutePlanning,
    VehicleList,
    AddVehicle,
    UpdateVehicle,
    DispatchPlanningList,
    AddDispatchPlanning,
    UpdateDispatchPlanning,
    DispatchPlanningDetails,
    CustomerCategoryList,
    AddCustomerCategory,
    UpdateCustomerCategory,
    DispatchAdviceList,
    AddDispatchAdvice,
    PaymentTermsList,
    AddPaymentTerms,
    UpdatePaymentTerms,
    DeliveryPlanningList,
    AddDeliveryPlanning,
    UpdateDeliveryPlanning,
    DeliveryPlanningDetails,
    StockTransferList,
    AddStockTransfer,
    SalesTargetList,
    UpdateSalesTarget,
    MerchandiseRackList,
    AddMerchandiseRack,
    UpdateMerchandiseRack,
    TourPlanList,
    AddTourPlan,
    AddReturnItem,
    VanStockReportList,
    SalespersonLiveLocation,
} from "../../pages/sales"

export const SalesImport = {
    RoutesMap,
    RegionList,
    AddRegion,
    UpdateRegion,
    GradeList,
    AddGrade,
    UpdateGrade,
    CustomerGroupList,
    AddCustomerGroup,
    UpdateCustomerGroup,
    CustomerTypeList,
    AddCustomerType,
    UpdateCustomerType,
    CustomerList,
    AddCustomer,
    UpdateCustomer,
    CustomerDetails,
    CategoryList,
    AddCategory,
    UpdateCategory,
    RoutesList,
    AddRoutes,
    UpdateRoutes,
    RouteDetails,
    CustomerRouteAssignmentList,
    AddCustomerRouteAssignment,
    UpdateCustomerRouteAssignment,
    CustomerSalesOrderList,
    AddCustomerSalesOrder,
    UpdateCustomerSalesOrder,
    DispatchAdviceRoutePlanning,
    VehicleList,
    AddVehicle,
    UpdateVehicle,
    DispatchPlanningList,
    AddDispatchPlanning,
    UpdateDispatchPlanning,
    DispatchPlanningDetails,
    CustomerCategoryList,
    AddCustomerCategory,
    UpdateCustomerCategory,
    DispatchAdviceList,
    AddDispatchAdvice,
    PaymentTermsList,
    AddPaymentTerms,
    UpdatePaymentTerms,
    DeliveryPlanningList,
    AddDeliveryPlanning,
    UpdateDeliveryPlanning,
    DeliveryPlanningDetails,
    StockTransferList,
    AddStockTransfer,
    SalesTargetList,
    UpdateSalesTarget,
    MerchandiseRackList,
    AddMerchandiseRack,
    UpdateMerchandiseRack,
    TourPlanList,
    AddTourPlan,
    AddReturnItem,
    VanStockReportList,
    SalespersonLiveLocation,
}